<template>
    <div class="researcher_page container-1200">
        <PageTitle title="Researcher Team" />

        <div class="researcher_list">
            <div class="researcher_item" v-for="(item, index) in researchersList" :key="index">
                <div class="researcher_avatar">
                    <img :src="item.img" :alt="item.authorName" />
                </div>

                <div class="researcher_content">
                    <div class="info">
                        <h3 class="name">{{ item.authorName }}</h3>
                        <p class="position">{{ item.position }}</p>
                        <p class="affiliation" :class="{ 'affiliation--full': !item.profile }">{{ item.affiliation }}</p>
                    </div>

                    <div class="action">
                        <button @click="handleViewMore(item)" v-if="item.detail || item.profile">
                            view more →
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <ResearcherDetailDialog ref="researcherDetailDialog" />
    </div>
</template>

<script>
import { researchersList } from "./data"
import PageTitle from "@/components/pageTitle/index.vue"
import ResearcherDetailDialog from "./researcherDetailDialog.vue"

export default {
    data() {
        return {
            researchersList
        }
    },
    components: {
        PageTitle,
        ResearcherDetailDialog
    },
    methods: {
        handleViewMore(item) {
            if (item.detail) {
                this.$refs.researcherDetailDialog.open(item)
                return
            }
            if (item.profile) {
                window.open(item.profile, '_blank')
            }
        }
    }
}
</script>

<style lang='scss' scoped>
.researcher_page {
    padding: 20px 0;
}

.researcher_list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.researcher_item {
    display: flex;
    background: #fff;
    border-radius: 22px;
    overflow: hidden;
    border: 1px solid #eef0f4;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    transition: 0.3s ease;
}

.researcher_item:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12);
}

/* 左侧整块图片区 */
.researcher_avatar {
    width: 240px;
    min-width: 240px;
    background: #f3f4f6;
    overflow: hidden;
}

.researcher_avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.4s ease;
}

.researcher_item:hover .researcher_avatar img {
    transform: scale(1.1);
}

.researcher_content {
    flex: 1;
    padding: 28px 34px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.name {
    font-size: 20px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 6px;
}

.position {
    font-size: 14px;
    font-weight: 600;
    color: #999999;
    margin-bottom: 12px;
}

.affiliation {
    font-size: 14px;
    line-height: 1.7;
    color: #6b7280;
    white-space: pre-line;
    max-width: 85%;

    &--full {
        max-width: 100%;
    }
}

/* 按钮 */
.action {
    display: flex;
    justify-content: flex-end;
}

.action button {
    background: #111827;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 22px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: 0.25s ease;
}

.action button:hover {
    background: #1da6b8;
    box-shadow: 0 6px 18px rgba(#1da6b8, 0.35);
}

@media (max-width: 768px) {
    .researcher_item {
        flex-direction: column;
    }

    .researcher_avatar {
        width: 100%;
        height: 240px;
    }

    .affiliation {
        max-width: 100%;
    }
}
</style>